import 'jquery-ajax-unobtrusive';
import '../../../scss/sites/fentex/fentex-style.scss';
import SvgIcon from '../../modules/svg-icon';
import AddressLookup from '../../modules/geolocate';
import * as Incrementer from '../../modules/incrementer';
import LightGallery from '../../modules/lightgallery';
import Recaptcha from '../../modules/recaptcha';
import FilterTags from '../../modules/filter-tags';
import LocatorA from '../../modules/locatorA';

document.addEventListener('DOMContentLoaded', () => {
  const svgIcon = new SvgIcon();
  const addressLookup = new AddressLookup({});
  const recaptcha = new Recaptcha({
    key: '6Leqkv8cAAAAACdVu2-Se-QGCMZq46orfZavBIW4'
  });
  const lightGallery = new LightGallery();
  const filterTags = new FilterTags();
  const locatorA = new LocatorA();

  svgIcon.init();
  addressLookup.init();
  lightGallery.init();
  Incrementer.default({});
  recaptcha.init();
  filterTags.init();
  locatorA.init();
});
